import { useEffect } from 'react';
import { useConfig } from '@salesforce/storefront-next-runtime/config';
import { initDatadog } from '@/lib/datadog.client';

export function DatadogProvider() {
    const appConfig = useConfig();

    useEffect(() => {
        if (appConfig.datadog) {
            initDatadog(appConfig.datadog);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return null;
}
